import type {HEXColor} from 'talptech-gis-components';

type Category = {
  code: string;
  value: number;
  color: HEXColor;
};

type Categories = Array<Category>;

const parseCategories = (param: string): Categories => {
  const elements = param.split(',');

  if (elements.length % 3 !== 0) {
    throw new Error('categories parameter needs a multiple of 3 number of elements');
  }

  if (elements.length < 3) {
    throw new Error('categories parameter needs at least 3 elements');
  }

  const categories: Categories = [];
  for (let c = 0; c < elements.length / 3; c++) {
    categories[c] = {
      code: elements[3 * c],
      value: Number(elements[3 * c + 1]),
      color: elements[3 * c + 2].startsWith('#') ? (elements[3 * c + 2] as HEXColor) : `#${elements[3 * c + 2]}`,
    };
  }
  return categories;
};

export default parseCategories;
